import React, { useState } from 'react';

const NojoomDashboardStatusShimmer = ({ data }) => {

  return (
    <>
    <div className='shimmer-h200 white_card mb-4' style={{margin: '0px 25px', height: '200px'}}>
        <div className=" p-3 mb-4">
          <div className="w-100  text-center d-flex justify-content-around">
            <h3 className="section_title_light text-center mb-0 shimmerBG w-50 d-flex "></h3>
          </div>
          <div className='d-flex w-100 justify-content-between w-100 justify-content-around' style={{margin: '15px auto 10px'}}>
          <div class="usage_box_slider shimmerBG shimmer-p-text height-10 mt-2 width-20"></div>
          <div class="usage_box_slider shimmerBG shimmer-p-text height-10 mt-2 width-20"></div>
          <div class="usage_box_slider shimmerBG shimmer-p-text height-10 mt-2 width-20"></div>
          <div class="usage_box_slider shimmerBG shimmer-p-text height-10 mt-2 width-20"></div>
          </div>
          <div className=" d-flex  w-100  text-center d-flex justify-content-around">
            
                <div className={` shimmerBG shimmer-h4 shimmer-h20 width-20 mb-0`}></div>
                <div className={` shimmerBG shimmer-h4 shimmer-h20  width-20 mb-0`}></div>
                <div className={` shimmerBG shimmer-h4 shimmer-h20 width-20 mb-0`}></div>
                <div className={` shimmerBG shimmer-h4 shimmer-h20 width-20 mb-0`}></div>
            
          </div>
          <div className='mt-4'>
            <div className="grey_badge d-flex justify-content-center">
              <label className='shimmerBG'></label>
             
            </div>
          </div>
        </div>
    </div>

    <div className="nojoom_points_bg shimmer-effect pse_sm">
        <div className="nojoom_points_overview mb-4  mt-3 white_card ">
          <div className="d-flex justify-content-between align-items-center z-3">
            <div className='w-40'>
              <label className='shimmer-effect  shimmer-p-text w-100 shimmerBG'></label>
              <h5 className="mt-1 mb-0 shimmer-effect shimmer-h25  w-50 shimmerBG"></h5>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between z-3 mt-30 ">
            <div className='w-60'>
              <label className='shimmer-effect shimmer-p-text w-75 shimmerBG'></label>
              <h5 className="mt-1 mb-0 shimmer-effect shimmer-h25 width-60 shimmerBG"></h5>
            </div>
            <div className="d-flex flex-column flex29 width-30" >
              <div className="d-flex align-items-center">
                <label className=' shimmer-effect shimmer-p-text w-75 shimmerBG'></label>
              </div>
              <h5 className="mt-1 mb-0 shimmer-effect  width-30 shimmer-h25 shimmerBG"></h5>
            </div>
          </div>
          <div className="d-flex justify-content-between mt-4">
            <div className="z-3 shimmer-effect shimmer-button-lg shimmerBG" style={{width: '30%'}}>
              <a className="me-2"></a>
            </div>
            <div className="z-3 shimmer-effect shimmer-button-lg shimmerBG" style={{width: '30%'}}>
              <a className="me-2"></a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NojoomDashboardStatusShimmer;
